/* eslint-disable react-hooks/exhaustive-deps */
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { useDeleteCognitoUserMutation } from "../../../../services/serverless";
import { useState } from "react";

interface DeleteUserModalProps {
  selectedUser: string;
  modalIsOpen: boolean;
  toggleModal: () => void;
}

export const DeleteUserModal = (props: DeleteUserModalProps) => {
  const [deleteCognitoUserMutation] = useDeleteCognitoUserMutation();

  const [errorMessage, setErrorMessage] = useState<string | null>();

  const handleDelete = async () => {
    try {
      await deleteCognitoUserMutation(props.selectedUser).unwrap();
      props.toggleModal();
    } catch (error) {
      setErrorMessage(
        `Error deleting user ${props.selectedUser}. Please try again later.`,
      );
    }
  };

  return (
    <Modal isOpen={props.modalIsOpen} toggle={props.toggleModal}>
      <ModalHeader toggle={props.toggleModal}>Delete User</ModalHeader>
      {!errorMessage && (
        <div>
          <ModalBody>
            Do you want to delete user {props.selectedUser}?
          </ModalBody>
          <ModalFooter>
            <Button
              color="primary"
              onClick={() => {
                handleDelete();
              }}
            >
              Yes
            </Button>
            <Button color="secondary" onClick={() => props.toggleModal()}>
              Cancel
            </Button>
          </ModalFooter>
        </div>
      )}
      {errorMessage && (
        <div>
          <ModalBody>{errorMessage}</ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={() => props.toggleModal()}>
              Close
            </Button>
          </ModalFooter>
        </div>
      )}
    </Modal>
  );
};
